import React from 'react'
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { TextField, Button, Switch, FormControlLabel, Alert } from '@mui/material';


import { useDispatch, useSelector } from 'react-redux';
import { deleteChron } from '../features/chronology';
import { setActive, key, deleteKey } from '../features/userKey';


export default function UserKey(props) {
  
  const dispatch = useDispatch()
  const k = useSelector(store => store.userKey.key) || ''
  const [value, setValue] = React.useState(k)

  const handleTextChaing = (event) => {
    setValue(event.target.value)
  }
  

  const handleSubmit = (event) => {
    event.preventDefault()
    dispatch(key(value))
    dispatch(setActive(true))
  }
  
  const handleDelete = () => {
    dispatch(deleteKey())
    dispatch(setActive(false))
  }

  return (
    <Modal
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Alert severity="warning">Attenzione: questa modifica potrebbe comportare errori nel funzionamento dell'app, <b>Tenere lo switch con valore di default: disattivato</b></Alert>
        <ActiveState /><hr />
        <Typography gutterBottom>Inserisci qui sotto la tua key</Typography>
        <form onSubmit={handleSubmit}>
          <TextField style={{ width:'100%', marginBottom:'10px' }} label="Open weather key" variant="filled" value={value} onChange={handleTextChaing} ></TextField>
          <br />
          <div className='row'>
            <div className="col-5">
              <Button style={{width:'100%'}} variant="contained" color='red' onClick={handleDelete}>Cancella</Button>
            </div>
            <div className="col-5 offset-2">
              <Button type='submit' style={{width:'100%'}} variant="contained">Invia</Button>
            </div>
          </div>
        </form>
        <hr />
        <Alert severity="info">Per ottenere una key di Open Weather recati a <a href='https://home.openweathermap.org/users/sign_in' rel='noreferrer' target='_blank' >questo link</a></Alert>

      </Box>
    </Modal>
  )
}

function ActiveState() {
  const isActive = useSelector(store => store.userKey.active)
  const dispatch = useDispatch()

  const handleToggleActive = (event) => {
    dispatch(setActive(event.target.checked))
  }

  return (
    <div className='row'>
      <FormControlLabel
        control={
          <Switch checked={isActive} onChange={handleToggleActive} />
        }
        label="Utilizza key personale"
      />
    </div>
  )
}

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  maxHeight:'90vh',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  borderRadius: '20px'
};